import React from 'react';
import featuredProvidersDesktopImg from '../assets/featured-providers-desktop.png';
import featuredProvidersMobileImg from '../assets/featured-providers-mobile.png';
import wellnessBg from '../assets/wellness-transparent.svg';
import wellnessMobileBg from '../assets/wellness-transparent-mobile.svg';
import { Box, BoxProps } from '../../../next-components/box';
import { Button, ButtonProps } from '../../../next-components/button';
import { Grid } from '../../../core-components/grid';
import { Typography } from '../../Typography';
export type PetInsurerWithFeaturedProviders = BoxProps & {
  heading?: string;
  subHeading?: string;
  ctaText?: string;
  ctaLink?: string;
  ctaProps?: ButtonProps;
};
export const PetInsurerWithFeaturedProviders = ({
  heading = 'Save on pet insurance for your pet',
  subHeading = 'You don\'t have to choose between your pet and your wallet when it comes to expensive vet visits. Prepare ahead of time for unexpected vet bills by finding the pawfect pet insurance.',
  ctaText = 'Compare plans',
  ctaLink = 'https://quote.petinsurer.com/quote/ref=wag',
  ctaProps,
  ...rest
}: PetInsurerWithFeaturedProviders) => <Box backgroundImage={[`url(${wellnessMobileBg})`, null, `url(${wellnessBg})`]} backgroundRepeat="no-repeat" backgroundPosition={['right bottom', 'right']} bg="#4669B2" borderRadius={[0, '16px']} p="32px" {...rest} data-sentry-element="Box" data-sentry-component="PetInsurerWithFeaturedProviders" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
    <Grid gridTemplateColumns={['1fr', null, '1.5fr 0.5fr']} gridGap="24px" justifyItems={['center', null, 'initial']} data-sentry-element="Grid" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
      <Box color="#FFFFFF" gridColumn={['unset', 1]} data-sentry-element="Box" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
        <Typography color="inherit" fontSize="24px" fontFamily="muliBold" m={0} data-sentry-element="Typography" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
          {heading}
        </Typography>
        <Typography color="inherit" data-sentry-element="Typography" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
          {subHeading}
        </Typography>
      </Box>
      <Box backgroundImage={[`url(${featuredProvidersMobileImg})`, `url(${featuredProvidersDesktopImg})`]} backgroundRepeat="no-repeat" backgroundSize="contain" height="40px" width="100%" gridColumn={['unset', null, '1 / 3']} data-sentry-element="Box" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx" />
      <Box gridColumn={['unset', null, 2]} gridRow={['unset', null, 1]} data-sentry-element="Box" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
        <Button bg="champagne" color="#85623e" variant="contained" fontFamily="muliBold" target="_blank" {...ctaProps} href={ctaLink} data-sentry-element="Button" data-sentry-source-file="PetInsurerWithFeaturedProviders.tsx">
          {ctaText}
        </Button>
      </Box>
    </Grid>
  </Box>;